/* eslint-disable jsx-a11y/no-redundant-roles */
import React from "react";
import { EnvelopeIcon, PhoneIcon } from "@heroicons/react/24/outline";
import { FaFilePdf } from "react-icons/fa";

// imported svg's
import { Svg2, Svg3 } from "./Subassets/Svg1";

const Footer = ({ getresume }) => {
  return (
    <>
      <>
        <footer
          className="py-3 bg-gradient-to-t from-slate-800 to-black"
          aria-labelledby="footer-heading"
        >
          <h2 id="footer-heading" className="sr-only">
            Footer
          </h2>

          <div className="w-full px-1 pt-6 pb-4 mx-auto sm:w-9/12 sm:px-6 lg:px-8">
            <div className="xl:grid xl:grid-cols-3 xl:gap-8">
              <article
                aria-label="get in touch"
                className="shadow-xl bg-slate-800/60 shadow-black"
              >
                <div className="py-20">
                  <hgroup className="relative pl-4 pr-8 mx-auto max-w-7xl sm:px-6 lg:px-8">
                    <h3 className="text-2xl font-bold tracking-tight text-stone-100 sm:text-3xl lg:text-5xl">
                      Get in touch
                    </h3>
                    <p
                      aria-label="contact info"
                      className="max-w-3xl pb-2 mt-6 text-lg text-stone-300"
                    >
                      {
                        " Contact to know more about me or fill the above form so i will get back to you as soon as possible and work together and create some more fantastic things."
                      }
                    </p>
                  </hgroup>
                </div>
              </article>
              <article
                aria-label="contact number/email"
                className="col-span-2 px-3 py-10 overflow-hidden shadow-xl sm:relative shadow-black bg-gradient-to-b from-cyan-900 to-teal-800 sm:px-6"
              >
                {/* Decorative angle backgrounds */}

                <div
                  className="absolute top-0 bottom-0 right-0 hidden w-1/2 pointer-events-none sm:block lg:hidden"
                  aria-hidden="true"
                >
                  <Svg2 />
                </div>
                <div
                  className="absolute top-0 bottom-0 right-0 hidden w-1/2 pointer-events-none lg:block"
                  aria-hidden="true"
                >
                  <Svg3 />
                </div>
                <h3 className="text-lg font-medium text-white">
                  Contact information
                </h3>

                <p className="max-w-3xl mt-6 text-base text-cyan-50"></p>
                <dl aria-label="contact methods" className="mt-8 space-y-6">
                  <dt aria-label="Resume">
                    <span className="sr-only">Resume</span>
                  </dt>
                  <dd
                    aria-label="check my resume"
                    className="flex text-base text-cyan-50"
                  >
                    <FaFilePdf
                      className="flex-shrink-0 w-6 h-6 text-cyan-200"
                      aria-hidden="true"
                    />{" "}
                    <button
                      type="button"
                      className="ml-4 active:outline-none focus:outline-none"
                      onClick={getresume}
                    >
                      {" "}
                      Check My Resume
                    </button>
                  </dd>
                  <dt aria-label="phone number">
                    <span className="sr-only">Phone number</span>
                  </dt>
                  <dd
                    aria-label="8178310882"
                    className="flex text-base text-cyan-50"
                  >
                    <PhoneIcon
                      className="flex-shrink-0 w-6 h-6 text-cyan-200"
                      aria-hidden="true"
                    />
                    <span className="ml-3">+91-8178310882</span>
                  </dd>
                  <dt aria-label="email">
                    <span className="sr-only">Email</span>
                  </dt>
                  <dd
                    aria-label="itiwariarun438@gmail.com"
                    className="flex text-base text-cyan-50"
                  >
                    <EnvelopeIcon
                      className="flex-shrink-0 w-6 h-6 text-cyan-200"
                      aria-hidden="true"
                    />
                    <span className="ml-3">itiwariarun438@gmail.com</span>
                  </dd>
                </dl>
              </article>
            </div>
            <div className="pt-8 mt-12 border-t border-slate-500">
              <p
                aria-label="copyright by arun"
                className="text-base text-center text-teal-100"
              >
                &copy; Coded With ❤ by Me(Arun)
              </p>
            </div>
          </div>
        </footer>
      </>
    </>
  );
};

export default Footer;
